import { hideElement, showElement } from "utils/toggle_element_visibility"
import Quimbee from 'quimbee'

export default function defineDeprecatedGlobal(global_func_name, func) {
  window[global_func_name] = function (...args) {
    if(!Quimbee.data.disableJSGlobalDeprecationWarnings) {
      console.warn(`Quimbee: Avoid using window.${global_func_name}. Instead, import it using ES6 modules`)
    }
    return func(...args)
  }
}

defineDeprecatedGlobal("hideElement", hideElement)
defineDeprecatedGlobal("showElement", showElement)
